import * as React from 'react';

function SvgIconUploadFile(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 11.99a.75.75 0 01-.75-.75V5.87L5.818 8.303l-1.06-1.06L9 3l4.243 4.243-1.06 1.06L9.75 5.871v5.369a.75.75 0 01-.75.75zM4.5 10.5H3v3A1.5 1.5 0 004.5 15h9a1.5 1.5 0 001.5-1.5v-3h-1.5v3h-9v-3z"
        fill="currentColor"
      />
    </svg>
  );
}

export const IconUploadFile = React.memo(SvgIconUploadFile);
